import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';

export class AllocationFilter extends FilterBase {
  makeIndex() {
    return new PourOver.makeRangeFilter('totalAllocation', [
      [0, 99],
      [100, 100]
    ]);
  }

  getMatchSet(collection, filterSettings) {
    if (filterSettings.showUnallocated) {
      return collection.filters.totalAllocation.getFn([0, 99]);
    } else {
      return null;
    }
  }

  getCounts() {
    return {
      unallocated: 0
    };
  }
}
